/*
 * The grid on /tickets, and nothing else.
 *
 * WHY THIS EXISTS AT ALL
 * ======================
 * The comparison grid needs three strings per competitor. Importing
 * ./index for them pulls all nine comparison pages — every table, every FAQ,
 * every quoted competitor fee, about 100 KB of prose — into the /tickets
 * landing chunk, which is the one page on the site whose whole design brief is
 * that it loads fast enough to feel cinematic. The prose belongs in the
 * `compare` chunk that ComparePage lazy-loads, and nowhere else.
 *
 * So this is a deliberate duplication of three fields, kept honest by
 * compare.test.js, which fails if this list and ./index disagree on the slugs,
 * their order, the competitor names or the taglines. Add a comparison in
 * ./index and the test tells you to add it here too.
 *
 * The ORDER here is the order of the grid: the self-serve platforms a creator
 * is realistically choosing between first, then the software subscription, then
 * the two marketplaces and the enterprise platform — which are on the list
 * because people compare them, not because they compete for the same job.
 */

const COMPARISON_LIST = [
  { slug: 'luma', competitor: 'Luma', tagline: 'Beautiful free RSVPs, card-first paid tickets' },
  { slug: 'explara', competitor: 'Explara', tagline: 'Association software with a box office attached' },
  { slug: 'townscript', competitor: 'Townscript', tagline: 'Cheaper per ticket, thinner after the sale' },
  { slug: 'meraevents', competitor: 'MeraEvents', tagline: 'Low organiser fee, a booking fee on the buyer' },
  { slug: 'konfhub', competitor: 'KonfHub', tagline: 'Tech conference ticketing, priced per event' },
  { slug: 'zoho-backstage', competitor: 'Zoho Backstage', tagline: 'A software subscription, no ticket commission' },
  { slug: 'bookmyshow', competitor: 'BookMyShow', tagline: 'A marketplace you apply to, not a tool you use' },
  { slug: 'district-by-zomato', competitor: 'District by Zomato', tagline: 'A going-out app that also sells tickets' },
  { slug: 'dreamcast', competitor: 'Dreamcast', tagline: 'Enterprise event production, quoted by sales' },
];

module.exports = { COMPARISON_LIST };
